/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Err_Weak_PasswordInputs */

const vi_user_err_weak_password = /** @type {(inputs: User_Err_Weak_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mật khẩu phải có ít nhất 8 ký tự`)
};

/**

* @param {User_Err_Weak_PasswordInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const user_err_weak_password = /** @type {((inputs?: User_Err_Weak_PasswordInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Err_Weak_PasswordInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_user_err_weak_password(inputs)
});